import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

type ButtonConfig = {
  icon?: string;
  text?: string;
  color?: 'primary' | 'accent' | 'warn';
  disabled?: boolean;
  border?: boolean;
};

const ButtonPresets: { [key: string]: ButtonConfig } = {
  authenticate: { icon: 'login', text: 'AUTHENTICATE', color: 'primary' },
  search: { icon: 'search', text: 'SEARCH', color: 'primary' },
  searchDisabled: { icon: 'search', text: 'SEARCH', color: 'primary', disabled: true},
  submitQuestion: { icon: 'auto_awesome', text: 'SUBMIT QUESTION', color: 'primary' },
  submitQuestionDisabled: { icon: 'auto_awesome', text: 'SUBMIT QUESTION', color: 'primary', disabled: true },
  submit: { text: 'SUBMIT', color: 'primary' },
  exportToPDF: { icon: 'description', text: 'EXPORT TO PDF', color: 'accent', border: true }
};

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, CommonModule, MatProgressSpinnerModule],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css']
})

export class ButtonComponent implements OnChanges {
  @Input() configKey?: keyof typeof ButtonPresets;
  @Input() customConfig?: ButtonConfig;
  @Input() isLoading: boolean = false; 
  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  icon?: string;
  text: string = '';
  color: 'primary' | 'accent' | 'warn' = 'primary';
  disabled: boolean = false;
  border: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['configKey'] && this.configKey) {
      const config = { ...ButtonPresets[this.configKey], ...this.customConfig };
      this.applyConfig(config);
      if (this.configKey === 'submit' && this.isLoading) {
        this.text = 'SUBMITTING';
      }
    } else if (changes['customConfig'] && this.customConfig) {
      this.applyConfig(this.customConfig);
    }
  }

  private applyConfig(config: ButtonConfig): void {
    if (config) {
      this.icon = config.icon || '';
      this.text = config.text || '';
      this.color = config.color || 'primary';
      this.disabled = config.disabled || false;
      this.border = config.border || false;
    }
  }

  handleClick(): void {
    if (!this.isLoading && !this.disabled) {
      this.onClick.emit();
    }
  }
}
